/* Shared resolver for document permalinks on docs.ballistol.co.uk.
   Used by the Technical Data Library section and the product-page
   document downloads. Exposes window.BallistolDocs. */
(function () {
  const DOCS_BASE = 'https://docs.ballistol.co.uk/';
  const compactText = s => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

  // Each rule: [groups, sds filename]. A rule matches when every group has at
  // least one term found in the compacted product title. First match wins, so
  // specific rules (e.g. "guncer spray") must come before generic ones ("guncer").
  const SDS_RULES = [
    [[['guncer'], ['grease', 'fett']], 'guncer-keramik-waffenfett-v3.0-englisch.pdf'],
    [[['guncer'], ['spray']], 'guncer-keramik-waffen-l-spray-v8.0-eng-lisch.pdf'],
    [[['guncer']], 'guncer-keramik-waffen-l-fl-ssig-v4.0-englisch.pdf'],
    [[['gunex'], ['spray']], 'gunex-mil-spray-v2.0-englisch.pdf'],
    [[['gunex']], 'gunex-mil-fl-ssig-v2.0-englisch.pdf'],
    [[['gunpart', 'waffenteile']], 'waffenteilereiniger-spray-v5.0-englisch.pdf'],
    [[['airsoft']], 'airsoft-gas-v9.1-englisch.pdf'],
    [[['sting', 'stichfrei'], ['tropical']], 'stichfrei-tropical-v2.0-englisch.pdf'],
    [[['sting', 'stichfrei'], ['animal']], 'stichfrei-animal-v7.0-englisch.pdf'],
    [[['sting', 'stichfrei'], ['kids', 'family']], 'stichfrei-lotion-kids-family-v4.0-englisch.pdf'],
    [[['sting', 'stichfrei'], ['tick', 'zecke']], 'stichfrei-zecke-v4.0-englisch.pdf'],
    [[['sting', 'stichfrei']], 'stichfrei-classic-v4.0-englisch.pdf'],
    [[['balsin']], 'balsin-schaft-l-sds-english.pdf'],
    [[['bikeclean']], 'bike-clean-sds-english.pdf'],
    [[['bikecer']], 'bike-cer-sds-english.pdf'],
    [[['degreaser']], 'cold-degreaser-sds-english.pdf'],
    [[['glassclean', 'glasclean', 'glasreiniger']], 'glas-reiniger-v3.1-englisch.pdf'],
    [[['h1']], 'ballistol-h1-spray-englisch.pdf'],
    [[['homeremedy', 'neoballistol']], 'home-remedy-sds-english.pdf'],
    [[['ptfe', 'teflon']], 'ballistol-ptfe-sds-english.pdf'],
    [[['pluvonin', 'impregnat', 'imprgnier']], 'impr-gnier-spray-v10.1-englisch.pdf'],
    [[['quickblue', 'schnellbr']], 'schnellbr-nierung-v6.0-englisch.pdf'],
    [[['resin']], 'harzl-ser-v5.0-englisch.pdf'],
    [[['robla']], 'robla-solo-mil-v3.0-englisch.pdf'],
    [[['silencer', 'schalld']], 'schalld-mpferreiniger-v3.0-englisch.pdf'],
    [[['silicon', 'silikon']], 'silikon-l-v6.0-englisch.pdf'],
    [[['universalclean', 'universalreiniger']], 'universal-reiniger-v3.1-englisch.pdf'],
    [[['universal', 'ballistol'], ['liquid']], 'universal-l-fl-ssig-v10.1-englisch.pd-f.pdf'],
    [[['universaloil', 'ballistolspray']], 'universal-oil-sds-english.pdf'],
    [[['vaseline']], 'vaseline-grease-sds-english.pdf'],
    [[['animal']], 'ballistol-animal-v5.0-englisch.pdf']
  ];

  function resolveSds(title) {
    const t = compactText(title);
    const hit = SDS_RULES.find(rule => rule[0].every(group => group.some(term => t.includes(term))));
    return hit ? DOCS_BASE + 'sds/' + hit[1] : null;
  }

  // Cover artwork for each flyer, from the same Files uploads the Technical
  // Data Library renders. Keyed by flyer slug so the cover always follows
  // whichever PDF resolveFlyer picks. `w` is a CDN transform width — the
  // source PNGs are print-resolution and far too heavy to ship raw.
  const CDN_FILES = 'https://cdn.shopify.com/s/files/1/0568/7525/3942/files/';
  const FLYER_COVERS = {
    'sting-free':   CDN_FILES + 'Stingfree-cover_320x.png?v=1721153318',
    'bicycle-care': CDN_FILES + 'Bicycle-Care-PDF-cover_320x.png?v=1721236265',
    'animal-care':  CDN_FILES + 'Flyer-Animal-Care-Cover_320x.png?v=1721235731',
    'universal-oil': CDN_FILES + 'UniversalOil-Coverpdf_320x.png?v=1721151544',
    'gun-care':     CDN_FILES + 'GunCare-Cover_320x.png?v=1721153223',
    'people-care':  CDN_FILES + 'People_Care-Pdf_Cover_320x.png?v=1721153732',
    'cleaner':      CDN_FILES + 'Cleaner-Flyer-PDF-Cover_1616b4ce-8764-4475-9720-60448b2ae051_320x.png?v=1721234635',
    'main-catalogue': CDN_FILES + 'Ballistol-Catalogue-PDF-Cover_320x.png?v=1721237809'
  };

  function flyerSlug(title, categories) {
    const t = compactText(title);
    const c = compactText(categories);
    if (t.includes('sting') || t.includes('stichfrei')) return 'sting-free';
    if (t.includes('bike') || c.includes('bike')) return 'bicycle-care';
    if (t.includes('animal') || c.includes('animalcare')) return 'animal-care';
    if (t.includes('universaloil') || t.includes('ballistolspray') || c.includes('universaloil')) return 'universal-oil';
    if (c.includes('weaponcare') || c.includes('weaponaccessories') || c.includes('guncare')) return 'gun-care';
    if (c.includes('peoplecare')) return 'people-care';
    if (t.includes('cleaner') || c.includes('cleaner')) return 'cleaner';
    return 'main-catalogue';
  }

  function resolveFlyer(title, categories) {
    const slug = flyerSlug(title, categories);
    return slug === 'main-catalogue'
      ? DOCS_BASE + 'catalogues/main-catalogue.pdf'
      : DOCS_BASE + 'product-flyers/' + slug + '.pdf';
  }

  function resolveFlyerCover(title, categories) {
    return FLYER_COVERS[flyerSlug(title, categories)] || null;
  }

  // Swap a failed/absent cover image for the same document glyph the SDS
  // card uses, so the plate never renders as a broken image.
  const DOC_GLYPH =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" ' +
    'stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>' +
    '<polyline points="14 2 14 8 20 8"></polyline>' +
    '<line x1="8" y1="13" x2="16" y2="13"></line>' +
    '<line x1="8" y1="17" x2="13" y2="17"></line></svg>';

  function coverFallback(img) {
    const plate = img.closest('.doc-cover');
    if (!plate) return;
    plate.classList.add('doc-cover--fallback');
    plate.innerHTML = DOC_GLYPH;
  }

  window.BallistolDocs = { DOCS_BASE, resolveSds, resolveFlyer, resolveFlyerCover };

  // Product page: fill in the document download links rendered by
  // sections/main-product.liquid (.product-documents containers).
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-documents').forEach(box => {
      const title = box.getAttribute('data-product-title');
      const categories = box.getAttribute('data-categories');

      const sdsLink = box.querySelector('.product-doc-sds');
      const sdsUrl = resolveSds(title);
      if (sdsLink) {
        if (sdsUrl) {
          sdsLink.href = sdsUrl;
          sdsLink.hidden = false;
        } else {
          sdsLink.remove();
        }
      }

      const flyerLink = box.querySelector('.product-doc-flyer');
      if (flyerLink) {
        flyerLink.href = resolveFlyer(title, categories);
        // The brochure varies by product, so its cover is set here rather
        // than in Liquid. If the image 404s, drop it and let the CSS fall
        // back to the generic PDF thumb instead of showing a broken icon.
        const cover = resolveFlyerCover(title, categories);
        const flyerImg = flyerLink.querySelector('.doc-cover-img');
        if (flyerImg) {
          if (cover) {
            flyerImg.addEventListener('error', () => coverFallback(flyerImg), { once: true });
            flyerImg.src = cover;
          } else {
            coverFallback(flyerImg);
          }
        }
        flyerLink.hidden = false;
      }

      // No empty-state message: when a product has no documents at all, hide
      // the whole block (including its "Download the official documentation"
      // intro) rather than leaving a heading over nothing.
      const anyDoc = box.querySelector('.product-doc-link:not([hidden])');
      if (!anyDoc) {
        // Only collapse the accordion-panel variant, which has an intro line
        // that would otherwise sit above nothing. The standalone downloads
        // snippet keeps its Technical Data Library link, which is still useful.
        const panel = box.closest('.product-description-content');
        if (panel) panel.hidden = true;
      }
    });
  });
})();
